var map = {
	"./Marketing materials.png": "030c",
	"./Present.png": "3a57",
	"./Regular umbrellas.png": "c4bd",
	"./belt.png": "65ec",
	"./belt_selected.png": "d88a",
	"./doming.png": "7cbc",
	"./doming_selected.png": "0a2e",
	"./input.png": "fd87",
	"./logo-yousee.png": "f95d",
	"./panel.png": "bcae",
	"./panel_selected.png": "c84a",
	"./ruler.png": "2559",
	"./scene.png": "09c1",
	"./scene_selected.png": "769a",
	"./side.png": "9f0b",
	"./side_selected.png": "80d1",
	"./sleeve.png": "6b76",
	"./sleeve_selected.png": "b2cb",
	"./top.png": "a6f2",
	"./top_selected.png": "f03d",
	"./transparent.png": "ed8e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5a20";